var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_85ab43ae"]},_vm.$listeners),[_c('div',{class:["toast-text-only-demo"]},[_c('cube-button',{on:{"_click":_vm.clickToast}},[_vm._v("Toast - text only")]),_c('cube-toast',{ref:"__mpx_ref_toast__",attrs:{"txt":"纯文案"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }